import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { boundariesCriteria, organisationTabCriteria, mobileAppCriteria } from '../../../utilities/epic-helpers';

import { objectNotEmpty } from '../../../utilities/helpers';

import {
  FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT,
  FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT_ERROR,
  SET_CATEGORY_AFFINITY_TOP_TOIS_REPORT
} from '../../constants';

const topPoisCategory = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/brand-affinity/top-pois?${
          organisationTabCriteria(state$)
          }${
          boundariesCriteria(state$)
          }${`&category=${encodeURIComponent(state$.value.brandAffinity.brandAffinityTopPoiCategoryOption.value)}`
          }${
            objectNotEmpty(state$.value.insightsCriteria.baseline) === true
            ? `&baseline=${state$.value.insightsCriteria.baseline.value}`
            : ''
          }${
            mobileAppCriteria(state$)
          }${
          `&period=${state$.value.brandAffinity.selectedPeriod.value}`
          }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_CATEGORY_AFFINITY_TOP_TOIS_REPORT,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT_ERROR,
            error,
          })
        )
      )
    )
  );

export default topPoisCategory;
